import * as Sentry from "@sentry/vue";

const SENTRY_DSN = window.env.VUE_APP_SENTRY_DSN;

const initialize = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/api\./],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  return Sentry;
};

export default { initialize };
